// extracted by mini-css-extract-plugin
module.exports = {"HomeBodyMain":"homeBody_HomeBodyMain__DGFSK","HomeBodyMainSideBarOpen":"homeBody_HomeBodyMainSideBarOpen__jFjQV"};